import CheckCircle from '@mui/icons-material/CheckCircle'
import dayjs from 'dayjs'
import {
  ALL_SUPPORTED_CATEGORY_TYPES_V2,
  ALL_TILE_ITEM_TYPES,
  TILE_CARD_VIEW_TYPES,
  TILE_LAYOUT_TYPE,
} from 'src/consumer/constants'
import { getCorrectUsableItemType } from '../../tile-carousels-utils'
import { SpreadBoard } from '../../tile-classes'

const SPREAD_BOARD_TILE_LOGIC_SETTERS = {
  [getCorrectUsableItemType(ALL_TILE_ITEM_TYPES.activityPlan)]: setActivityPlanTileItemLogic,
}

const SPREAD_BOARD_TILE_LOGIC_SETTER_FOR_CATEGORY_TYPE = {
  [ALL_SUPPORTED_CATEGORY_TYPES_V2.activePlans]: setActivePlanCategoryTypeLogic,
}

export function getSpreadBoardTileLogic(itemType, tileData, { navigate }) {
  const tileLogicData = new SpreadBoard({ tileData })
  const carouselMakerFunction = SPREAD_BOARD_TILE_LOGIC_SETTERS?.[tileLogicData?.currentItemType]

  carouselMakerFunction &&
    carouselMakerFunction(tileLogicData, {
      navigate,
    })
  return tileLogicData
}

function setActivityPlanTileItemLogic(tileItemLogic, { navigate }) {
  let defaultTileItemLogicWithTileData = tileItemLogic
  const currentItemType = defaultTileItemLogicWithTileData.currentItemType
  let getSecondaryText = (item) => 'Activity Plan'

  let onClickLogic = (item) => {
    const currentItem = item?.[currentItemType]
    navigate(!!currentItem?.slug ? `/plan/${currentItem?.slug}` : `/plan/id/${currentItem?.id}`)
  }

  defaultTileItemLogicWithTileData.setTitleField((item) => {
    return item?.[currentItemType]?.title
  })
  defaultTileItemLogicWithTileData.setMainImage((item) => item?.[currentItemType]?.coverIcon)
  defaultTileItemLogicWithTileData.setSecondaryCardImage((item) => item?.coverIcon)
  defaultTileItemLogicWithTileData.setSecondaryTextFunction(getSecondaryText)
  defaultTileItemLogicWithTileData.setActionButtonLogic((item) => ({
    text: 'Start',
    onClick: onClickLogic,
  }))

  if (
    SPREAD_BOARD_TILE_LOGIC_SETTER_FOR_CATEGORY_TYPE[
      defaultTileItemLogicWithTileData?.currentCategoryType
    ]
  ) {
    SPREAD_BOARD_TILE_LOGIC_SETTER_FOR_CATEGORY_TYPE?.[
      defaultTileItemLogicWithTileData?.currentCategoryType
    ](defaultTileItemLogicWithTileData, { navigate })
  }
}

function setActivePlanCategoryTypeLogic(tileItemLogic, { navigate }) {
  // const tileItemLogic = Object.create(currentTileItemLogicObject)
  const currentItemType = tileItemLogic.currentItemType
  const currentTileData = tileItemLogic.tileData

  const onClickLogic = (item) =>
    navigate(`/my-activity/${item?.[currentItemType]?.slug}`, {
      state: { planId: item?.[currentItemType]?.id, slug: item?.[currentItemType]?.slug },
    })

  //   tileItemLogic.setSecondaryItemsFunction((item) => item?.[currentItemType]?.plannedActivities)

  tileItemLogic.setSecondaryItemsFunction((item) => item?.[currentItemType]?.plannedActivities)
  tileItemLogic.setSecondaryItemImage((parentItem, item, index) => item?.coverIcon)
  tileItemLogic.setSecondaryItemTitle(
    (parentItem, item, index) => item?.plannedActivity?.activityTitle,
  )
  tileItemLogic.setSecondaryItemSecondaryText(
    (parentItem, item, index) => item?.plannedActivity?.customCategoryTitle,
  )
  tileItemLogic.setSecondaryItemsFunction((item) => {
    return (item?.[currentItemType] || {}).plannedActivities.map((pAct, pIdx) => {
      const today = dayjs().local().startOf('day')
      const pActToUse = {
        ...pAct,
        _currentDay: item?.userActivityProgressLog
          ? pIdx + 1 === item?.userActivityProgressLog?.plannedDay
          : pIdx === 0,
        _completedToday: item?.userActivityProgressLog
          ? moment
              .utc(item?.userActivityProgressLog?.attemptedDay)
              .local()
              .startOf('day')
              .isSame(today)
          : false,
      }
      return {
        ...pActToUse,
        _pActivityLocked: item?.userActivityProgressLog
          ? pIdx + 1 > item?.userActivityProgressLog?.plannedDay
          : pIdx + 1 > 1,
      }
    })
  })
  tileItemLogic.setSecondaryTextFunction((item) => item?.[currentItemType]?.description)
  tileItemLogic.setSecondaryItemViewType((item, idx) => {
    return !!item?._pActivityLocked ? TILE_CARD_VIEW_TYPES.locked : TILE_CARD_VIEW_TYPES.default
  })
  //   tileItemLogic.setPreselected((item) => {
  //     return !!item?._currentDay
  //   })
  tileItemLogic.setBoxedMainTitleText((item, index) => {
    return `Day`
  })
  tileItemLogic.setBoxedMainTitleSubText((item, index) => {
    return `${index + 1}`
  })

  tileItemLogic.setSecondaryItemOnClick((parentItem, item, sbIndex) => {
    console.log({ parentItem })
    navigate(`/my-activity/${parentItem?.[currentItemType]?.slug}`)
  }) //TODO: open the respective planned activity here.

  tileItemLogic.setTertiaryTitle((parentItem, item, idx) => {
    return (
      ((!item._currentDay && !item._pActivityLocked) || item?._completedToday) && (
        <>
          <CheckCircle sx={{ color: '#39ff37' }} />
          <span>Completed</span>
        </>
      )
    )
  })
  currentTileData?.layout === TILE_LAYOUT_TYPE.squareMid &&
    tileItemLogic.setSecondaryTextFunction((item) => 'Active Plan')

  tileItemLogic.setActionButtonLogicFunction((item) => {
    return {
      text: 'Continue',
      onClick: onClickLogic,
    }
  })
  // tileItemLogic.getSecondaryItemViewType((secondaryItem)=>)
}
